import { User } from "firebase/auth";
import { Company } from "../model/Companies"
import { Messages, SendDateAndEventDateList } from "../model/Message"
import { getDayAndCount, getDayOfWeek, setSendDate, setSendDateAndNumberOfWeek } from "../utility/RepeatPublishUtility";
import { ConstValue } from "../config/const";

export class MessagingCommonFunctions {
  main = () => {}

  // お知らせ登録処理
  submit = async (
    data: Messages,
    type: 'draft' | 'send' | 'preview',
    onlineUrlSelected: string | undefined,
    currentUser: User | null,
    selectedEventType: string,
    base64Image: string,
    company: Company | undefined,
    tenantId?: string
  ) => {
      // string型の日付けをDate型に変換
      data.sendDate = new Date(data.sendDate);
      // URLリンクボタン
      if(!data.urlButtonFlg || data.urlButtonFlg === undefined) {
        delete data.urlButtonFlg;
        delete data.urlButtonName;
        delete data.urlLink;
      };
      // 登録者
      data.authorUid = currentUser?.uid ?? "";
      data.authorName = currentUser?.displayName ?? '運営管理者';
      // 登録団体
      data.tenantId = tenantId ?? "";
      // 配信先団体番号を登録
      data.topic = [company?.displayId!];
      data.select = company?.displayId! ?? '';
      // イベント時刻空欄フラグ
      data.isEventTimeEmpty = data.eventAtTime === undefined
        || data.eventAtTime === ''
        || data.eventEndAtTime === undefined
        || data.eventEndAtTime === '';
      // イベントタイプ
      data.eventType = selectedEventType;
      // 画像
      data.image = base64Image;

      // 初めの配信日
      let sendDateSelected = new Date(
        data.sendDate.getFullYear(),
        data.sendDate.getMonth(),
        data.sendDate.getDate(),
        data.sendDate.getHours(),
        data.sendDate.getMinutes()
      );
      // 掲載終了日が設定されている場合
      let publishEndAtSelected = undefined;
      if(data.publishEndAt !== undefined) {
        publishEndAtSelected = new Date(
          data.publishEndAt.getFullYear(),
          data.publishEndAt.getMonth(),
          data.publishEndAt.getDate(),
          data.publishEndAt.getHours(),
          data.publishEndAt.getMinutes()
        );
      };
      // 配信日のリストを作成
      let sendDateList: SendDateAndEventDateList[] = [];

      if(!data.draftFlg && type === 'send' && data.regularFlg
        && data.regularSetting !== undefined){
        // 繰り返し設定から配信日を追加
        const reguler = data.regularSetting;
        // 繰り返し配信終了日のタイプ判定
        const endDate = (reguler.endDateType === 'endDate'
          && reguler.endDate !== undefined)
            ? new Date(reguler.endDate)
            : new Date(
              sendDateSelected.getFullYear() + 2,
              sendDateSelected.getMonth(),
              sendDateSelected.getDate(),
              sendDateSelected.getHours(),
              sendDateSelected.getMinutes()
            );
        // 回数指定の場合
        const maxCount = (reguler.endDateType === 'numberOfRepeats'
        && reguler.numberOfRepeats !== undefined)
          ? (reguler.numberOfRepeats * 1) - 1
          : 730;

        // 初めのイベント設定日時
        let selectEventAt = new Date(
          data.eventAt.getFullYear(),
          data.eventAt.getMonth(),
          data.eventAt.getDate(),
          data.eventAt.getHours(),
          data.eventAt.getMinutes()
        );
        let selectEventEndAt = new Date(
          data.eventEndAt.getFullYear(),
          data.eventEndAt.getMonth(),
          data.eventEndAt.getDate(),
          data.eventEndAt.getHours(),
          data.eventEndAt.getMinutes()
        );
        // イベントの場合は配信日をイベント開催のn日前に設定
        const offsetDateNum = data.regularSetting?.previousDeliveryDate;

        if(reguler?.repeatIntervalType === 'weekly'
          && reguler.dayOfWeek !== undefined){
          // n週間ごとの場合
          // sendDateから配信終了日または回数(最大2年分)までの対象曜日日付けを抽出
          const intervalDate = 7 * reguler.repeatIntervalNum;
          for(let i = 0; i < reguler.dayOfWeek.length; i++){
            // 最初の配信日の直近のw曜日を取得
            if(reguler.dayOfWeek[i]){
              const firstDay = data.eventFlg
                ? new Date(
                  selectEventAt.getFullYear(),
                  selectEventAt.getMonth(),
                  selectEventAt.getDate() - (offsetDateNum ?? 0),
                  selectEventAt.getHours(),
                  selectEventAt.getMinutes())
                : getDayOfWeek(sendDateSelected, i);
              const firstEventAt = data.eventFlg ? getDayOfWeek(selectEventAt, i) : undefined;
              const firstEventEndAt = data.eventFlg ? getDayOfWeek(selectEventEndAt, i) : undefined;
              const list = setSendDate(
                firstDay, publishEndAtSelected,  endDate,
                firstEventAt, firstEventEndAt, offsetDateNum,
                maxCount, undefined, undefined, intervalDate
              );
              sendDateList = [...sendDateList, ...list];
            };
          };
        } else if(reguler?.repeatIntervalType === 'monthly') {
          // nか月ごと
          const intervalMonth = 1 * reguler.repeatIntervalNum;
          const firstDay = sendDateSelected;
          const firstEventAt = data.eventFlg
            ? selectEventAt : undefined;
          const firstEventEndAt = data.eventFlg
            ? selectEventEndAt : undefined;
          let list: SendDateAndEventDateList[] = [];
          if(reguler?.everyMonthType === 'day'){
            // 毎月n日の場合
            list = setSendDate(
              firstDay, publishEndAtSelected, endDate,
              firstEventAt, firstEventEndAt, offsetDateNum,
              maxCount, undefined, intervalMonth, undefined
            );
          } else if(reguler?.everyMonthType === 'week'){
            // 毎月第n w曜日の場合
            const {day, count} = getDayAndCount(sendDateSelected);
            const event = data.eventFlg ? getDayAndCount(selectEventAt) : undefined;
            const eventEnd = data.eventFlg ? getDayAndCount(selectEventEndAt) : undefined;
            const publishEnd = publishEndAtSelected !== undefined ? getDayAndCount(publishEndAtSelected) : undefined;
            list = setSendDateAndNumberOfWeek(
              firstDay, publishEndAtSelected, endDate,
              firstEventAt, firstEventEndAt, offsetDateNum,
              maxCount, undefined, intervalMonth, undefined,
              day, count,
              event?.day, event?.count,
              eventEnd?.day, eventEnd?.count,
              publishEnd?.day, publishEnd?.count,
            );
          };
          sendDateList = [...sendDateList, ...list];
        };
      };
      if(type !== 'preview') {
        // リンク
        const link = onlineUrlSelected !== '' ? onlineUrlSelected : data.url;
        data.link = link?.match(/^https:\/\/$/) !== null || link === undefined  ? '' : link;
        // 配信日時
        delete data.sendDateTime;
        // イベント開始日時
        delete data.eventAtTime;
        // イベント終了日時
        delete data.eventEndAtTime;
        // 掲載終了日時
        if(data.publishEndAt !== undefined){
          data.publishEndAt = new Date(data.publishEndAt);
          delete data.publishEndAtTime;
        } else {
          delete data.publishEndAt;
          delete data.publishEndAtTime;
        };
        // 下書き・新規登録
        data.draftFlg = type === 'draft';
        // 繰り返し設定完了後、パラメータを削除
        delete data.regularFlg;
        delete data.regularSetting;
      }
      // 繰り返さない場合の対応
      if(sendDateList.length < 1) {
        sendDateList.push({sendDate: data.sendDate, eventAt: new Date(data.eventAt), eventEndAt: new Date(data.eventEndAt)});
      }
      sendDateList.sort((a, b) => a > b ? 1 : -1);
      const sendData = data;
      return {sendDateList, sendData};
  };

  imageFileToBase64Image = (file: File, setBase64Image: React.Dispatch<React.SetStateAction<string>>) => {
    const img = new Image();
    img.onload = () => {
      // アップロードできる最大サイズ
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      const maxW = ConstValue.IMG_MAX_WH;
      const maxH = ConstValue.IMG_MAX_WH;
      const iw = img.width;
      const ih = img.height;

      let iwScaled = iw;
      let ihScaled = ih;
      if(maxW < iw || maxH < ih) {
        // 縦横いずれかが最大幅を超える場合、リサイズ
        let scale = Math.min((maxW/iw), (maxH/ih));
        iwScaled = iw * scale;
        ihScaled = ih * scale;
      }
      canvas.width = iwScaled;
      canvas.height = ihScaled;
      ctx?.drawImage(img, 0, 0, iwScaled, ihScaled);

      // ファイルサイズが指定値を下回るまで 品質を 0.1 ずつ低下させる
      let base64Str;
      let quality = 0.9;
      do {
        base64Str = canvas.toDataURL('image/jpeg', quality);
        console.debug(` -- Base64Size：${base64Str.length} / 品質：${quality}`);
        quality = quality - 0.1;
      } while (base64Str.length > ConstValue.IMG_MAX_FILE_SIZE);

      console.log(` -- Base64Size：${base64Str.length} / 品質：${quality + 0.1} / width：${iwScaled} / height：${ihScaled}`);
      setBase64Image(base64Str);
    };
    img.src = URL.createObjectURL(file);
  };
};